import { ClaimStatus } from "../types/claims.types";
import { formatClaimStatus } from "../helpers/claims.helper";

export function useAllowedClaimStatuses(selectedClaimsStatuses: ClaimStatus[]) {
    if (selectedClaimsStatuses.length === 0) return [];

    const hasOnHold = selectedClaimsStatuses.includes(ClaimStatus.ON_HOLD);
    const allReadyForSubmission = selectedClaimsStatuses.every(
        (s) => s === ClaimStatus.READY_FOR_SUBMISSION
    );

    if (hasOnHold) {
        return [ClaimStatus.READY_FOR_SUBMISSION];
    }

    const allStatuses = Object.values(ClaimStatus).sort((a, b) =>
        formatClaimStatus(a).localeCompare(formatClaimStatus(b))
    );

    if (allReadyForSubmission) {
        return allStatuses;
    }

    return allStatuses.filter((s) => s !== ClaimStatus.ON_HOLD);
}
